module.exports = __webpack_public_path__ + "img/logo-generic-light.ff0a604f.svg";